import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { AppContextProvider } from '../../../AppLoader';
import { ThemedText } from '../../../ThemedComponents';
import { DeviceRadioList } from '../../WixAppEnforcement/DeviceRadioList';
import { EnableErrorSectionHelper } from '../../WixAppEnforcement/EnableErrorSectionHelper';

/**
 * device-selection step of the owner-app add-auth wizard (wix-2025) — shows the
 * single connected device by name, or a `DeviceRadioList` to pick one.
 */
export const OwnerAppSelectDeviceBody: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  return (
    <Box direction="vertical" width="100%" gap={2}>
      <EnableErrorSectionHelper />
      <ThemedText>{t('addOwnerApp.wizard.choose.label')}</ThemedText>
      {store.devices.length === 1 ? (
        <ThemedText weight="bold">{store.devices[0].name}</ThemedText>
      ) : (
        <DeviceRadioList />
      )}
    </Box>
  );
});
